import {WithoutSummaryModel} from "../../../../../../../common/entity/dto/plain/withoutSummary.model";

export class TreatmentJourneyStepReminderModel extends WithoutSummaryModel {
    emailSubject: string;
    emailContent: string;
}